"use strict";

var _slicedToArray = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/slicedToArray.js");

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("react");

var frontend_theme_1 = require("@ryerson/frontend.theme");

var frontend_application_1 = require("@ryerson/frontend.application");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_typography_1 = require("@ryerson/frontend.typography");

var react_2 = require("@emotion/react");

var __1 = require("..");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var PasswordContent_1 = require("./PasswordContent");

var addInputMargin = (0, react_2.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\tmargin-bottom: 19px;\n"])));
var confirmPasswordInputMargin = (0, react_2.css)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n\tmargin-bottom: 30px;\n"])));
var passwordRequirementsMargin = (0, react_2.css)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n\tmargin-bottom: 30px;\n"])));
var addWidth = (0, react_2.css)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n\twidth: 100%;\n"])));
var requirementLabelMargin = (0, react_2.css)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n\tmargin-top: 5px;\n\tmargin-bottom: 5px;\n"])));
var iconMargin = (0, react_2.css)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n\tmargin-top: 3px;\n\tmargin-right: 15px;\n"])));
var passwordCriteriaTitle = (0, react_2.css)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n\tmargin-bottom: 16px;\n\twhite-space: pre-wrap;\n"])));

var Password = function Password(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? "set" : _ref$type,
      handlePasswordChange = _ref.handlePasswordChange;

  var _ref2 = (0, frontend_application_1.useApplication)(),
      language = _ref2.localization.language;

  var _ref3 = (0, frontend_theme_1.useTheme)(),
      theme = _ref3.theme;

  var _theme$colors$primary = theme.colors.primary,
      success = _theme$colors$primary.success,
      secondaryBrand = _theme$colors$primary.secondaryBrand;
  var inputRef = (0, react_1.useRef)();

  var _ref4 = (0, react_1.useState)(""),
      _ref5 = _slicedToArray(_ref4, 2),
      newPassword = _ref5[0],
      setNewPassword = _ref5[1];

  var _ref6 = (0, react_1.useState)(""),
      _ref7 = _slicedToArray(_ref6, 2),
      currentPassword = _ref7[0],
      setCurrentPassword = _ref7[1];

  var _ref8 = (0, react_1.useState)(false),
      _ref9 = _slicedToArray(_ref8, 2),
      showCurrentPassword = _ref9[0],
      setShowCurrentPassword = _ref9[1];

  var _ref10 = (0, react_1.useState)(false),
      _ref11 = _slicedToArray(_ref10, 2),
      showNewPassword = _ref11[0],
      setShowNewPassword = _ref11[1];

  var _ref12 = (0, react_1.useState)(false),
      _ref13 = _slicedToArray(_ref12, 2),
      showConfirmPassword = _ref13[0],
      setShowConfirmPassword = _ref13[1];

  var _ref14 = (0, react_1.useState)(""),
      _ref15 = _slicedToArray(_ref14, 2),
      confirmPassword = _ref15[0],
      setConfirmPassword = _ref15[1];

  var _ref16 = (0, react_1.useState)(),
      _ref17 = _slicedToArray(_ref16, 2),
      isValid = _ref17[0],
      setIsValid = _ref17[1];

  var isUpdatePassword = type === "update";
  var validators = [{
    id: "length",
    validate: function validate(val) {
      return val.length >= 8 && val.length <= 200;
    },
    message: PasswordContent_1.PasswordContent[language].validation.lengthText
  }, {
    id: "chars",
    validate: function validate(val) {
      return /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/.test(val);
    },
    message: PasswordContent_1.PasswordContent[language].validation.charsText
  }, {
    id: "passwordsmatch",
    validate: function validate(val) {
      return val.length && val === confirmPassword;
    },
    message: PasswordContent_1.PasswordContent[language].validation.matchText
  }];
  (0, react_1.useEffect)(function () {
    var _a;

    (_a = inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  }, []);
  (0, react_1.useEffect)(function () {
    if (isUpdatePassword && isValid && currentPassword) {
      handlePasswordChange(confirmPassword, currentPassword);
    } else if (isValid) {
      handlePasswordChange(confirmPassword);
    } else {
      handlePasswordChange("");
    }
  }, [isValid, currentPassword]);
  (0, react_1.useEffect)(function () {
    setIsValid(validators.map(function (validator) {
      return validator.validate(newPassword);
    }).every(Boolean));
  }, [newPassword, confirmPassword, currentPassword]);

  var handleNewPasswordChange = function handleNewPasswordChange(event) {
    var value = event.target.value;
    setNewPassword(value);
  };

  var handleCurrentPasswordChange = function handleCurrentPasswordChange(event) {
    var value = event.target.value;
    setCurrentPassword(value);
  };

  var handleConfirmPasswordChange = function handleConfirmPasswordChange(event) {
    var value = event.target.value;
    setConfirmPassword(value);
  };

  var renderCurrentPasswordInput = function renderCurrentPasswordInput() {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
      style: addInputMargin,
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        children: PasswordContent_1.PasswordContent[language].inputCurrentPasswordLabelText
      }), (0, jsx_runtime_1.jsx)(__1.Input, {
        placeholder: "",
        value: currentPassword,
        inputType: showCurrentPassword ? "text" : "password",
        icon: showCurrentPassword ? "no-view" : "view",
        iconLabel: showCurrentPassword ? PasswordContent_1.PasswordContent[language].passwordHideText : PasswordContent_1.PasswordContent[language].passwordShowText,
        onChange: handleCurrentPasswordChange,
        onIconClick: function onIconClick() {
          return setShowCurrentPassword(!showCurrentPassword);
        },
        css: {
          marginTop: "5px"
        },
        language: language
      })]
    });
  };

  var renderNewPasswordInput = function renderNewPasswordInput() {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
      style: addInputMargin,
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        children: PasswordContent_1.PasswordContent[language].inputNewPasswordLabelText
      }), (0, jsx_runtime_1.jsx)(__1.Input, {
        placeholder: "",
        value: newPassword,
        inputType: showNewPassword ? "text" : "password",
        icon: showNewPassword ? "no-view" : "view",
        iconLabel: showNewPassword ? PasswordContent_1.PasswordContent[language].passwordHideText : PasswordContent_1.PasswordContent[language].passwordShowText,
        onChange: handleNewPasswordChange,
        onIconClick: function onIconClick() {
          return setShowNewPassword(!showNewPassword);
        },
        css: {
          marginTop: "5px"
        },
        language: language
      })]
    });
  };

  var renderConfirmPasswordInput = function renderConfirmPasswordInput() {
    return (0, jsx_runtime_1.jsxs)(frontend_layout_1.FlexItem, {
      style: confirmPasswordInputMargin,
      children: [(0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
        size: "md",
        children: PasswordContent_1.PasswordContent[language].inputConfirmPasswordLabelText
      }), (0, jsx_runtime_1.jsx)(__1.Input, {
        placeholder: "",
        value: confirmPassword,
        inputType: showConfirmPassword ? "text" : "password",
        icon: showConfirmPassword ? "no-view" : "view",
        iconLabel: showConfirmPassword ? PasswordContent_1.PasswordContent[language].passwordHideText : PasswordContent_1.PasswordContent[language].passwordShowText,
        onChange: handleConfirmPasswordChange,
        onIconClick: function onIconClick() {
          return setShowConfirmPassword(!showConfirmPassword);
        },
        css: {
          marginTop: "5px"
        },
        language: language
      })]
    });
  };

  var renderPasswordRequirements = function renderPasswordRequirements(password) {
    return (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: passwordRequirementsMargin,
      children: (0, jsx_runtime_1.jsx)(frontend_layout_1.Flex, {
        direction: "column",
        children: validators.map(function (validator) {
          var isValid = validator.validate(password);
          return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
            alignItems: "flex-start",
            style: requirementLabelMargin,
            children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
              style: iconMargin,
              children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
                size: "xs",
                color: isValid ? success : secondaryBrand,
                icon: isValid ? "check" : "minus"
              })
            }), (0, jsx_runtime_1.jsx)(frontend_typography_1.Typography, {
              size: "md",
              css: {
                maxWidth: "90%"
              },
              children: validator.message
            })]
          }, validator.id);
        })
      })
    });
  };

  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    direction: "column",
    style: addWidth,
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: passwordCriteriaTitle,
      children: (0, jsx_runtime_1.jsxs)(frontend_typography_1.Typography, {
        size: "md",
        children: [PasswordContent_1.PasswordContent[language].resetPasswordText, ":"]
      })
    }), renderPasswordRequirements(newPassword), isUpdatePassword && renderCurrentPasswordInput(), renderNewPasswordInput(), renderConfirmPasswordInput()]
  });
};

exports.default = Password;